export default class ImagePanner {
  constructor(containers, scene) {
    this.containers = containers;
    this.isDragging = false;
    this.startX = 0;
    this.startY = 0;
    this.scene = scene;
    this.enabled = false;
  }

  enable() {
    this.enabled = true;
    this.scene.input.on("pointerdown", this.startDrag, this);
    this.scene.input.on("pointermove", this.onDrag, this);
    this.scene.input.on("pointerup", this.endDrag, this);
  }

  disable() {
    this.enabled = false;
    this.scene.input.off("pointerdown", this.startDrag, this);
    this.scene.input.off("pointermove", this.onDrag, this);
    this.scene.input.off("pointerup", this.endDrag, this);
  }

  startDrag(pointer) {
    this.isDragging = true;

    // Registra la posizione iniziale del mouse o tocco
    this.startX = pointer.x;
    this.startY = pointer.y;

    this.scene.ct.querySelector("canvas").classList.add("js-is-panning");
  }

  onDrag(pointer) {
    if (!this.isDragging) return;

    // Calcola lo spostamento
    const deltaX = pointer.x - this.startX;
    const deltaY = pointer.y - this.startY;

    // Muovi tutti i contenitori in Phaser
    this.containers.forEach((container) => {
      if (container.clip) {
        container.clip.x += deltaX;
        container.clip.y += deltaY;
      }
    });

    // Aggiorna la posizione iniziale per il prossimo movimento
    this.startX = pointer.x;
    this.startY = pointer.y;
  }

  endDrag() {
    this.scene.ct.querySelector("canvas").classList.remove("js-is-panning");
    this.isDragging = false;
  }
}
